import { render } from "./EditTitleView.vue?vue&type=template&id=e2984082"
import script from "./EditTitleView.vue?vue&type=script&lang=js"
export * from "./EditTitleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__